/**
 * Copyright ©2022 Drivepoint
 */

import React, {useEffect, useState} from "react";
import {Toolbar} from "@mui/material";
import ThemedAppBar from "../widgets/styled/ThemedAppBar";
import useStateChange from "../hooks/useStateChange";
import BainbridgeUser from "../services/user/BainbridgeUser";

export default function TopAppBar(props: any): JSX.Element {

  const user = useStateChange<BainbridgeUser>("user");
  const chrome = useStateChange<string>("chrome");

  const [hideChrome, setHideChrome] = useState<boolean>();

  useEffect(() => {
    setHideChrome(!user || chrome === "disabled");
  }, [user, chrome]);

  const classes = [`${hideChrome ? "hidden" : ""}`].join(" ");

  return <ThemedAppBar className={classes}  position="relative">
    <Toolbar className={classes}>
      {props.children}
    </Toolbar>
  </ThemedAppBar>;

}
